import styled from "styled-components";
import { colorPalette } from "@ui-library/myslpro"
import { colorPalette as colorPalette2 } from "_shared/styles/color"
import { SkeletonLoaderDiv, SkeletonLoaderTitle } from "_shared/styles/skeletonLoader";

export const Header = styled(SkeletonLoaderDiv)`
  display: flex;
  border-bottom: 1px solid ${colorPalette2.greyLight};
  background-color: ${colorPalette.cloud};
  padding: 15px;
  width: 100%;
`;

export const Content = styled(SkeletonLoaderDiv)`
  display: inline-flex;
  width: 100%;
  & > *:first-child {
    border-right: 1px solid ${colorPalette2.greyLight};
    width: 60%;
  }
`;

export const ChildContainer = styled.div`
  border-radius: 15px;
  overflow: hidden;
  border: 1px solid ${colorPalette2.greyLight};
`;

export const ParentContainer = styled.div`
  display: grid;
  padding: 0px 20px;
  gap: 20px;
`;

export const Title = styled(SkeletonLoaderTitle)`
  width: 100%;
  font-size: 32px;
  margin-bottom: 0px;
  color: ${colorPalette.black};
`;

export const DashboardContainer = styled(SkeletonLoaderDiv)`
  width: 100%;
`;


export const TabsContainer = styled(SkeletonLoaderDiv)`
  width: 35%;
  min-height: 45px;
`;

export const Line = styled.div`
  display: inline-flex;
  justify-content: space-between;

  div[data-testid="gsl.uilib.Autocomplete"] {
    margin-top: 25px;
  }
`;